import { PLACEHOLDER_APP_ICON } from "./constants";

export const getGeneratedImageUrl = (selectedApi?: string | null) => {
  if (!selectedApi) return PLACEHOLDER_APP_ICON;
  return `${process.env.NEXT_PUBLIC_ZAPIER_ORIGIN}/generated/${selectedApi}/64/`;
};

export const getAppName = (selectedApi?: string | null) => {
  if (!selectedApi) return "";
  // This trims API and CLI out of the string, then does the same for
  // a trailing V2, then adds spaces between capitalized letters
  return selectedApi
    .replaceAll(/(API|CLI)/g, "")
    .replace(/V2$/, "")
    .replaceAll(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2")
    .trim();
};

export const getServicesFromApis = (
  selectedApis?: (string | null | undefined)[] | null,
) => {
  if (!selectedApis?.length) return [];
  return selectedApis.map((selectedApi) => ({
    name: getAppName(selectedApi),
    src: getGeneratedImageUrl(selectedApi),
  }));
};
